export const FINANCE_APPROVAL_QUERY_KEY = ["finance-approval"];
export const FINANCE_APPROVAL_QUERY_KEY_ID = (lotId: string) => [
  ...FINANCE_APPROVAL_QUERY_KEY,
  lotId,
];

export const GST_INVOICES_QUERY_KEY = ["gst-invoices"];

export const ALTERATIONS_LIST_QUERY_KEY = ["alterationApprovals"];
